import * as React from "react";
const SvgCheckItem = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 12, viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.5 1.00049L5.44946 11.0005L1 8.14542", stroke: "#303030", strokeWidth: 0.833333 }));
export default SvgCheckItem;
